"use strict";

var React = require("react");

var SvgIconArrow = function SvgIconArrow() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 16 19",
      fill: "none",
    },
    /*#__PURE__*/ React.createElement("path", {
      d:
        "M2.868 17.444L1.46 1.998l12.672 8.942-7.022.393-.253.014-.138.211-3.851 5.886z",
      stroke: "currentColor",
      fill: "transparent",
    })
  );
};

exports["foreignIcon"] = SvgIconArrow;
